import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import "./Sezione.css";
import ImgCard from "./ImgCard";
import ShareButton from "./ShareButton";

const Sezione = () => {
    

    //"useParamas" è un hook fornito da React Router che permette di accedere ai parametri dell'URL
    //Restituisce un oggetto contenente tutti i parametri definiti dinamicamente nell'URL.
    //In "App.js" ho questo: <Route path="/sezione/:id" element={<Sezione />} />
    //"/sezione/:id" definisce un parametro dinamico chiamato "id". Il valore di "id" cambierà a seconda 
    // dell'URL.
    //Quando l'utente naviga su un URL come /sezione/123, React Router riconosce che il valore 123 è il parametro "id"
    //Con "useParams", puoi accedere a questo valore e utilizzarlo nel tuo componente.
    const {slug } = useParams(); //Estraiamo sia ID che slug dall'URL
    
    const navigate = useNavigate(); // Navigazione per tornare indietro
    const [sezione, setSezione] = useState(null);
    
    //Stato per gestire il menù mobile o desktop
    const [menuOpen, setMenuOpen] = useState(false);

    //Creazione di un riferimento al nodo "sezioni" del database
    //Con "get" recupro i dati in tempo reale
    //Con "snapshot.exists()" verifico se il nodo esiste.
    //  Se esiste: I dati vengono estratti e cercati (con .find()) usando l'id della sezione
    //  fornito dalla URL. I dati trovati vengono salvati nello stato "sezione"
    
    useEffect(() => {
        const sezioneRef = ref(database, `sezioni`);
        get(sezioneRef).then((snapshot) => {
            if (snapshot.exists()) {
                const sezioni = snapshot.val();
                //Convertiamo "id" in numero per evitare problemi di confronto
                const datiSezione = sezioni.find((sez)=> sez.slug === slug);
                if(datiSezione){
                    setSezione(datiSezione);
                }
            else {
                console.log("Sezione non trovata.");
            }} 
        });
    }, [slug]);
    //Mostra un messaggio di caricamento se i dati non sono ancora disponibili.
    if (!sezione) {
        return <p>Caricamento...</p>;
    }
    //Uso "navigate(-1)" per tornare alla pagina precedente
    //Iterazione sull'array:
    // - "sezione.articoli.map()" passa in rassegna ogni oggetto contenuto nell'array "articoli".
    //Ceazione di un <li> per ogni articolo:
    // - Per ogni oggetto nell'array, viene creato un <li> con un valore unico per la proprietà "key".
    //   La "key" è necessaria per aiutare React a gestire in modo efficiente la lista.
    //Link per Navigazione
    // All'interno di ogni <li>, un componente <Link> crea un collegamento alla pagina specificata dell'articolo.
    // L'URL sarà basato sull'id dell'articolo.
    return (
        <div>
            <nav className="navbar">
          <div className="logo">
            10<span>curiosita</span>.it
          </div>
          {/*Icona menù per dispositivi mobili */}
          <div className="menu-icon" onClick={()=> setMenuOpen(!menuOpen)}>
            ☰
          </div>
          {/* Menù di navigazione */}
          <ul className={`menu ${menuOpen ? "open" : ""}`}>
            <li><a href="/">Home</a></li>
            <li><a href="/articoli">Articoli</a></li>
            <li><a href="/curiosità-del-giorno">Curiosità del giorno</a></li>
            <li><a href="/contatti">Contatti</a></li>
          </ul>
        </nav>
            {/* <button className="back-button" onClick={() => navigate(-1)}>
                Torna indietro
            </button> */}
            <section>
            <div className="container-secondario">
                <div className="container-terziario">
                    <h1 className="sezione-title">{sezione.titolo}</h1>
                    <p className="sezione-description">{sezione.descrizione}</p>
                    <ShareButton/>
                </div>

            {sezione.articoli && sezione.articoli.length > 0 ? (
                
                <>
                    <h2 className="articolo-title"></h2>
                    {/* <ul className="articolo-list">
                        {sezione.articoli.map((articolo) => (
                            <li key={articolo.id} className="articolo-item">
                                <Link to={`/articolo/${articolo.slug}`} className="articolo-link">
                                    {articolo.titolo}
                                </Link>
                            </li>
                        ))}
                    </ul> */}

                <div className="articolo-grid">
                    {sezione.articoli.map((articolo) => (
                        <ImgCard
                        key={articolo.id}
                        titolo={articolo.titolo}
                        slug={articolo.slug}
                        pathImmagine={articolo.immaginePath}
                        onClick={() => navigate(`/articolo/${articolo.slug}`)}
                        tipo="articolo"
                        />
                    ))}
                </div>
                </>
            ) : (
                <p className="no-articoli">Non ci sono articoli disponibili.</p>
            )}
            </div>
            </section>
        </div>
    );
};

export default Sezione;
